import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import $ from 'jquery';

import Layout from '../components/Layout'
import SEO from '../components/SEO'
import HeroText from "../components/HeroText"
import { WiTime9 } from "react-icons/wi";
import background from "../img/service_section_bg_2.png"
import { FaMapMarkerAlt, FaMobileAlt, FaEnvelope, FaAt, FaLinkedinIn } from "react-icons/fa"
import { FaSquareXTwitter } from "react-icons/fa6";
//import Recaptcha from 'react-recaptcha'

export class ContactPageTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isValidated: false,
      g_recaptcha_response: '',
      fullName: '',
      email: '',
      message: ''
    }
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  handleMainChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleMainSubmit = e => {
    $.ajax({
      url: "https://71jmri3wtj.execute-api.us-west-2.amazonaws.com/production/",
      type: "POST",
      dataType: "JSON",
      data: JSON.stringify({
        ReplyTo: this.state.email,
        Name: this.state.fullName,
        Comments: this.state.message,
        Subject: "New submission from Contact Us - Page",
        Gotcha: this.state.verifyAddress,
        GoogleRecaptchaResponse: "klmkwelkm2-mk2ml2389u4nkfejhijfrw0"
      }),
      processData: false,
      success: function (data, textStatus, jQxhr) {
        window.location.href = "/thanks";
      },
      error: function (jqXhr, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
    e.preventDefault();
  }

  verifyCallback = response => {
    this.setState({ g_recaptcha_response: response });
  };

  render() {
    const { seo, hero } = this.props
    return (
      <div>
        <SEO title={seo.title} description={seo.description} />
        <HeroText data={hero} />
        <section className="section"
            style={{
              backgroundImage: `url(${ background })`,
              backgroundPosition: `center center`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              height: '700',
              padding: '5rem 0'
            }}>
          <div className="container">
            <div className="contact">
              <div className="columns contact-columns">
                <div className="contact-content">
                  <div className="wrapper">
                    <span className="label contact-wrapper">
                      <div className="icon">
                        <FaMobileAlt />
                      </div>
                      <div  className="content-wrapper">
                        <span className="footer-title">Phone:</span>
                        <a href="tel:17205888133" className="small-text">1+(720)-588-8133</a>
                      </div>
                    </span>
                    <span className="label contact-wrapper display-none-md">
                      <div className="icon" style={{ paddingLeft: '0.1rem', transform: 'translateY(5px)' }}>
                        <FaEnvelope />
                      </div>
                      <div className="content-wrapper">
                        <span className="footer-title">Email:</span>
                        <a href="mailto:info@cypressdatadefense.com" className="small-text">info@cypressdatadefense.com</a>
                      </div>
                    </span>
                    <span className="label contact-wrapper display-none-md">
                      <div className="icon">
                        <FaMapMarkerAlt />
                      </div>
                      <div style={{ marginTop: '0.5rem' }}>
                        <span className="footer-title">Address:</span>
                        <a href="https://www.google.com/maps?q=14143+Denver+west+parkway+suite+100+golden+co+80401">
                        <div className="address-wrapper">
                          <div className="small-text">14143 Denver West Pkwy<br></br>Suite 100<br></br>Golden, CO 80401</div>
                        </div>
                        </a>
                      </div>
                    </span>
                    <span className="label contact-wrapper">
                      <div className="icon"  style={{ paddingLeft: '0.2rem' }}>
                        <FaAt />
                      </div>
                      <div style={{ marginTop: '0.5rem' }}>
                        <span className="footer-title">Follow us on:</span>
                        <div className="small-text"><a  href="https://www.linkedin.com/company/cypressdatadefense/"><FaLinkedinIn /></a><a style={{ paddingLeft: "1rem"}} href="https://x.com/cddsecurity"><FaSquareXTwitter /></a></div>
                        <div className="small-text">For the latest updates and insights.</div>
                      </div>
                    </span>
                  </div>
                  <div className="flex-column">
                  <span className="label contact-wrapper">
                      <div className="icon" style={{ paddingLeft: '0.1rem', transform: 'translateY(5px)' }}>
                        <FaEnvelope />
                      </div>
                      <div className="content-wrapper">
                        <span className="footer-title">Email:</span>
                        <a href="mailto:info@cypressdatadefense.com" className="small-text">info@cypressdatadefense.com</a>
                      </div>
                    </span>
                  <span className="label contact-wrapper">
                      <div className="icon">
                        <FaMapMarkerAlt />
                      </div>
                      <div style={{ marginTop: '0.5rem' }}>
                        <span className="footer-title">Address:</span>
                        <a href="https://www.google.com/maps?q=14143+Denver+west+parkway+suite+100+golden+co+80401">
                        <div className="address-wrapper">
                          <div className="small-text">14143 Denver West Pkwy<br></br>Suite 100<br></br>Golden, CO 80401</div>
                        </div>
                        </a>
                      </div>
                    </span>
                    </div>
                </div>
                <div className="form-wrapper">
                  <p className="has-text">Let's Secure your SDLC Together</p>
                  <form
                    name="contact"
                    id="contact"
                    onSubmit={this.handleMainSubmit}
                  >
                    <div className="field">
                      <div className="columns">
                        <div className="column is-6">
                          <label htmlFor={'fullName'}>
                            Full name
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              type={'text'}
                              name={'fullName'}
                              onChange={this.handleMainChange}
                              id={'fullName'}
                              required={true}
                              placeholder="Your Full Name"
                            />
                          </div>
                        </div>
                        <div className="column is-6">
                          <label htmlFor={'email'}>
                            Email Address
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              type={'email'}
                              name={'email'}
                              onChange={this.handleMainChange}
                              id={'email'}
                              required={true}
                              placeholder="Your Email Address"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor={'message'}>
                        Message
                      </label>
                      <div className="control">
                        <textarea
                          className="textarea"
                          name={'message'}
                          onChange={this.handleMainChange}
                          id={'message'}
                          required={true}
                          placeholder="Message..."
                        />
                      </div>
                    </div>
                    <div className="field" style={{ paddingTop: '2rem' }}>
                      <button className="btn-golden" style={{ padding: "0.5rem 4rem" }}  type="submit">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    )
  }
}

ContactPageTemplate.propTypes = {
  seo: PropTypes.object,
  hero: PropTypes.object,
}

const ContactPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark
  return (
    <Layout>
      <ContactPageTemplate
        seo={frontmatter.seo}
        hero={frontmatter.hero}
      />
    </Layout>
  )
}

ContactPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    })
  }),
}

export default ContactPage

export const pageQuery = graphql`
  query ContactPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "contact-page" } }) {
      frontmatter {
        seo {
          title
          description
        }
        hero {
          title
          secondtitle
          description
          image {
            childImageSharp {
              fluid(maxWidth: 2600, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
